<template>
  <div>
    <logo :url="baseData.images.logo || baseData?.logoUrl" />
    <div v-if="$t('title_text')">
      <h2
        :key="$i18n.locale"
        :style="titleTextStyles"
        v-text="replacePredefinedVariables($t('title_text'))"
      />
    </div>

    <header-carousel v-if="isCarousel" :base-data="baseData" />
    <!-- //TODO: check how will this work on new payload structure -->
    <div
      v-if="!baseData.fbPayload && !baseData.facebookGeneratedCampaign"
      v-html="baseData.headerHtml"
    />
  </div>
</template>

<script>
  import HeaderCarousel from './header-image/header.vue'
  import Logo from '../logo/logo.vue'
  import { replacePredefinedVariables } from '../../helpers'

  export default {
    components: {
      HeaderCarousel,
      Logo,
    },
    props: ['baseData'],
    computed: {
      isCarousel() {
        return Array.isArray(this.baseData.images.header)
      },
      titleTextStyles() {
        return {
          'font-size': `${this.baseData.sizes.titleTextSize} !important`,
          color: `${this.baseData.colors.textColor}`,
        }
      },
    },
    methods: {
      replacePredefinedVariables,
    },
  }
</script>
